module.exports = __webpack_public_path__ + "static/media/just_mint.c388ef77.png";